<div class="exception-body error">
    <div class="exception-panel">
        <div class="exception-image">
            <img src="assets/layout/images/exception/icon-error.png">
        </div>

        <div class="exception-detail">
            <h1>¡Ups!</h1>
            <p>Algo malo pasó, intente más tarde</p>
            <p-button label="IR AL INICIO" [routerLink]="['/']"></p-button>
        </div>
    </div>
</div>
